import { Field, ErrorMessage } from "formik";
import { CMErrorMessage, CMField, CMFormControl } from "./input-field.styles";

export const FormField = ({ field, form, max, maxLength, ...props }) => {
  return <CMField {...field} max={max} maxLength={maxLength} {...props} />;
};

export const FormMessage = ({ name, error }) => {
  return (
    <CMErrorMessage variant="caption" name={name}>
      {error}
    </CMErrorMessage>
  );
};

const InputField = ({
  id,
  label,
  name,
  error,
  isInvalid,
  sx,
  className,
  max,
  maxLength,
  password,
  ...props
}) => {
  const hasError = isInvalid ? { error: true } : { error: false };

  return (
    <CMFormControl sx={sx} className={className} {...hasError}>
      <Field
        name={name}
        id={id}
        max={max}
        maxLength={maxLength}
        {...props}
        className={`${hasError.error ? "error" : ""}`}
        component={FormField}
      />
      {error && !password && (
        // <ErrorMessage
        //   key={error}
        //   name={name}
        //   error={error}
        //   children={
        <CMErrorMessage variant="caption" name={name}>
          {error}
        </CMErrorMessage>
        //   }
        // />
      )}
    </CMFormControl>
  );
};

export default InputField;
